interface CardNotesProps {
  notes?: string[];
}

// Small grey lines under a card's description that explain how its numbers are counted
export function CardNotes({ notes }: CardNotesProps) {
  if (!notes?.length) return null;

  return (
    <div className="tw:flex tw:flex-col tw:gap-0.5 tw:text-xs tw:text-neutral-500 tw:dark:text-neutral-400">
      {notes.map((note) => (
        <p key={note} className="tw:m-0">
          {note}
        </p>
      ))}
    </div>
  );
}
